import React from 'react';
import PropTypes from 'prop-types';
import connectStore from 'decorators/connectStore';
import I18nStore from 'stores/I18nStore';

@connectStore(I18nStore, 'i18nState')
class MobileMenuControllerContainer extends React.Component {
  render() {
    return (
      <MobileMenuController {...this.props} />
    );
  }
}

class MobileMenuController extends React.Component {
  static propTypes = {
    i18nState: PropTypes.object.isRequired,
    menus: PropTypes.object.isRequired,
    menuProps: PropTypes.object,
    resetState: PropTypes.bool.isRequired,
  };

  static default = 'default';

  constructor(props) {
    super(props);
    this.transitionToMenu = this.transitionToMenu.bind(this);

    this.state = { currentMenu: MobileMenuController.default };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.resetState === false && nextProps.resetState === true) {
      this.setState({ currentMenu: MobileMenuController.default });
    }
  }

  // If we're closing the menu, componentWillRecieveProps will reset the state to default
  // but we don't want to rerender in that case as it will break the close css transition
  shouldComponentUpdate(nextProps) {
    return !(this.props.resetState === false && nextProps.resetState === true);
  }

  transitionToMenu(newMenu) {
    const nextMenu = this.props.menus[newMenu] === undefined
      ? MobileMenuController.default : newMenu;
    this.setState({ currentMenu: nextMenu });
  }

  render() {
    const { i18nState, menus, menuProps } = this.props;
    const { currentMenu } = this.state;
    const props = {
      transitionToMenu: this.transitionToMenu,
      currentLocale: i18nState.currentLocale,
      ...menuProps,
    };
    return React.createElement(menus[currentMenu], props);
  }
}

/* With Babel 6, React classes wrapped in containers
need to explicitly export static class variables (AUTHOR-5234) */
const defaultMenu = MobileMenuController.default;
export { defaultMenu };
export default MobileMenuControllerContainer;
